import { render, staticRenderFns } from "./IboxTitle.vue?vue&type=template&id=90942066&scoped=true&"
import script from "./IboxTitle.vue?vue&type=script&lang=js&"
export * from "./IboxTitle.vue?vue&type=script&lang=js&"
import style0 from "./IboxTitle.vue?vue&type=style&index=0&id=90942066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90942066",
  null
  
)

export default component.exports